namespace TabAurous.HR {
    export interface SalaryPackageForm {
        Code: Serenity.StringEditor;
        Narration: Serenity.StringEditor;
        TotalAmount: Serenity.DecimalEditor;
        IsDisabled: Serenity.BooleanEditor;
        PackageDetails: SalaryPackageDetailsEditor;
    }

    export class SalaryPackageForm extends Serenity.PrefixedContext {
        static formKey = 'HR.SalaryPackage';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SalaryPackageForm.init)  {
                SalaryPackageForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.BooleanEditor;
                var w3 = SalaryPackageDetailsEditor;

                Q.initFormType(SalaryPackageForm, [
                    'Code', w0,
                    'Narration', w0,
                    'TotalAmount', w1,
                    'IsDisabled', w2,
                    'PackageDetails', w3
                ]);
            }
        }
    }
}
